import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        result: css`
            padding: 20px;
            font-size: ${theme.typography.h3.fontSize}px;
            line-height: ${theme.typography.h3.lineHeight};
            color: ${theme.palette.secondary[600]};
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
        `,
        button: css`
            ${custom.button};
            margin: 30px 25px 20px 25px;
        `,
        error: css`
            color: ${theme.palette.error.main};
            font: normal normal 400 ${theme.typography.h4.fontSize}px/${theme.typography.h4.lineHeight} Roboto;
            margin-top: 4px;
        `,
    }
}

export default styles
